import React, { useEffect, useState } from 'react';

import { games } from "../portfolio";
import {
    Container,
    Row,
} from "reactstrap";
import GamesCard from "../components/GamesCard";
import { Fade } from 'react-reveal';

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mql = window.matchMedia('(max-width: 767px)');
        const onChange = () => setIsMobile(mql.matches);
        onChange();

        if (typeof mql.addEventListener === 'function') {
            mql.addEventListener('change', onChange);
            return () => mql.removeEventListener('change', onChange);
        }

        mql.addListener(onChange);
        return () => mql.removeListener(onChange);
    }, []);

    return isMobile;
};

const Games = () => {
    const isMobile = useIsMobile();
    return ( 
        <section className="section section-lg">
            <Container>
                {isMobile ? (
                    <>
                        <div className="d-flex p-4">
                            <div>
                                <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-info">
                                    <i className="fa fa-gamepad text-info" />
                                </div>
                            </div>
                            <div className="pl-4">
                                <h4 className="display-3 text-info">Games</h4>
                            </div>
                        </div>
                        <Row className="row-grid align-items-center">
                            {games.map((data, i) => (
                                <GamesCard key={i} data={data} />
                            ))}
                        </Row>
                    </>
                ) : (
                    <Fade bottom duration={1000} distance="40px">
                        <>
                            <div className="d-flex p-4">
                                <div>
                                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-info">
                                        <i className="fa fa-gamepad text-info" />
                                    </div>
                                </div>
                                <div className="pl-4">
                                    <h4 className="display-3 text-info">Games</h4>
                                </div>
                            </div>
                            <Row className="row-grid align-items-center">
                                {games.map((data, i) => (
                                    <GamesCard key={i} data={data} />
                                ))}
                            </Row>
                        </>
                    </Fade>
                )}
            </Container>
          </section>
     );
}
 
export default Games;